import { isEmail, useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validatePassword,
	validatePhoneNumber,
	validateUsername,
} from '../../../util/validation/commonValidation';
import type { NewOrganisationDto } from '../types/NewOrganisationDto';

const defaultOrganisation: NewOrganisationDto = {
	name: '',
	username: '',
	password: '',
	checkPassword: '',
	email: '',
	phoneNumber: '',
	connectionString: '',
};

export function useAddOrganisationForm() {
	const [inputs, setInputs] = useState<NewOrganisationDto>(defaultOrganisation);

	const form = useForm<NewOrganisationDto>({
		mode: 'uncontrolled',
		initialValues: defaultOrganisation,
		validate: {
			name: (value) => validateOrganisationName(value),
			connectionString: (value) => validateConnectionString(value),
			password: (value) => validatePassword(value, false),
			checkPassword: (value, values) => {
				// biome-ignore lint/suspicious/noDoubleEquals: <explanation>
				if (value != values.password) {
					return 'Passwords do not match';
				}
			},
			email: isEmail('Email is invalid'),
			phoneNumber: (value) => validatePhoneNumber(value, false),
			username: (value) => validateUsername(value),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}

export function validateConnectionString(value: string) {
	if (value.length > 250) {
		return 'Connection string cannot exceed 250 characters';
	}
	if (value.length < 1) {
		return 'Connection string cannot be empty';
	}
}

export function validateOrganisationName(value: string) {
	if (value.length < 1) {
		return 'Organisation name cannot be empty';
	}
	if (value.length > 130) {
		return 'Organisation cannot exceed 130 characters';
	}
	if (!/^\w[\w.\-#&\s]*$/.test(value)) {
		return 'Organisation name can only include letters, numbers, spaces, and the following special characters are allowed: .- # &';
	}
}
